import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Ctas from '../../../Core/Ctas';

import SpecialOfferCard from './SpecialOfferCard';
import {
  StyledContainer,
  Heading,
  Subheading,
  ContentWrapper,
  Disclaimer,
} from './styles';

const OfferDetails = ({ data }) => {
  if (!data) return null;

  const {
    component,
    anchorName,
    backgroundColor,
    theme,
    contentAlignment,
    elements,
    sectionContainerHeading,
    sectionContainerHeadingColor,
    sectionSubheading,
    sectionContainerSubheadingColor,
    ctas,
    legalCopy,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading $textColor={sectionContainerHeadingColor}>{children}</Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading $textColor={sectionContainerHeadingColor}>{children}</Heading>
      ),
    },
  };

  const subhead = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Subheading $textColor={sectionContainerSubheadingColor}>
          {children}
        </Subheading>
      ),
    },
  };

  const disclaimer = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Disclaimer $textColor={sectionContainerHeadingColor}>
          {children}
        </Disclaimer>
      ),
    },
  };

  return (
    <StyledContainer
      id={anchorName}
      backgroundColor={backgroundColor}
      $contentAlignment={contentAlignment}
      className={`${theme} ${component}`}
    >
      {sectionContainerHeading && (
        <RichText document={sectionContainerHeading} options={header} />
      )}
      {sectionSubheading && (
        <RichText document={sectionSubheading} options={subhead} />
      )}
      <ContentWrapper role="list" columnCount={elements.length}>
        {elements &&
          elements.map(el => {
            return <SpecialOfferCard data={el} key={el.id} />;
          })}
      </ContentWrapper>
      {legalCopy && <RichText document={legalCopy} options={disclaimer} />}
      {ctas && <Ctas ctas={ctas} position={contentAlignment} />}
    </StyledContainer>
  );
};

OfferDetails.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default OfferDetails;
